import type { ReactNode } from "react";

import { DotSpiralLoader } from "@/components/ui/dot-spiral-loader";
import { cn } from "@/lib/utils";

export type LoadingStateProps = {
  message?: ReactNode;
  ariaLabel?: string;
  loaderSize?: number;
  dotSize?: number;
  className?: string;
  loaderClassName?: string;
  messageClassName?: string;
};

export function LoadingState({
  message,
  ariaLabel,
  loaderSize = 36,
  dotSize = 5,
  className,
  loaderClassName,
  messageClassName,
}: LoadingStateProps) {
  const loaderLabel = ariaLabel ?? (typeof message === "string" ? message : "Loading");

  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 text-center", className)}>
      <DotSpiralLoader
        ariaLabel={loaderLabel}
        className={cn("text-primary", loaderClassName)}
        dotSize={dotSize}
        size={loaderSize}
      />
      {message ? <p className={cn("text-sm text-muted-foreground", messageClassName)}>{message}</p> : null}
    </div>
  );
}
